var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",staticStyle:{"border":"none"}},[_c('list',{ref:"list"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }